import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DropdownEditorComponent } from '@irb-common/components/grid/editors/dropdown-editor.component';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { ImportSecurityCategorySecuritiesDialogComponent } from './import-security-category-securities-dialog.component';
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownFilterRendererComponent} from '@irb/irb-common/components/grid/renderers/dropdown-filter.cell.component';

@Injectable({
    providedIn: 'root'
})
export class ImportSecurityCategoryNoninventoriedGridLayoutService implements GridLayoutService<ImportSecurityCategorySecuritiesDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "DropdownEditorComponent": DropdownEditorComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "DropdownFilterRendererComponent": DropdownFilterRendererComponent
        };
    }

    getColumnDefs(parent: ImportSecurityCategorySecuritiesDialogComponent) {
        return [{
            headerName: 'Select All',
            headerComponent: 'customHeader',
            cellRenderer : 'customHeader',
            cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
            suppressColumnsToolPanel: true,
            suppressSizeToFit: true,
            toolPanelClass: 'toolpanel-header-checkbox-hide',
            headerComponentParams: {parentObject: parent, type: 'headerCheckBox',cbSelectAllInpChecked:true },
            suppressMovable: true,
            lockPosition: true,
            lockVisible: true,
            sortable: false,
            filter: true,
            resizable: false,
            minWidth: 25,
            width: 25,
            maxWidth:25,
            cellStyle: {'padding' : '5px 3px 0 2px'},
            headerClass: 'customHeaderClassSelectAll',
            cellClass: 'selectAllCheckBoxRecord'
        },{
            headerName: 'Symbol/CUSIP',            
            field: 'securitySymbol',
            maxWidth: 130,
            width: 130
        },
        {
            headerName: 'Description',
            field: 'securityDescription',
            maxWidth: 371,
            cellRenderer: "TruncateTooltipCellComponent"
        },
        {
            headerName: 'Type',
            field: 'securityType',
            maxWidth: 140,
            width: 140
        },
        {
            headerName: 'Custom Category',
            field: 'customCategoryId',
            maxWidth: 170,
            width: 170,
            colId: "custCategoryCol",
            cellRenderer: 'DropdownFilterRendererComponent',
            cellRendererParams: (params: any) => {
                let d = {value: "0", name: "Uncategorized"} as IDropdownItem;
                
                if(params.data.customCategoryId) {
                    d = parent.securitiesCustomCategories.find((x: IDropdownItem) => x.value === params.data.customCategoryId);
                }

                return {
                    defaultValue: d,
                    values: parent.securitiesCustomCategories,
                    onChange: (params: any, item: IDropdownItem) => {
                        params.data.customCategoryId = item.value;
                        params.data.customCategoryName = item.name;
                    },
                    onClearSelection: (params: any) => {
                        params.data.customCategoryId = "0";
                        params.data.customCategoryName = "Uncategorized";
                        params.api.redrawRows({rowNodes: [params.node]});
                    }
                };
            },
            cellClass: 'dropdownFilterCell'
        }];
    }
}
